import { useRef } from 'react';
import { useDaily } from '@daily-co/daily-react';

export const useRecordings = () => {
  const callObject = useDaily();

  const recordingStatus = useRef(false);

  /**
   * Waits for a 'recording-started' event
   * If it doesn't arrive in 60 seconds, rejects with a timeout error.
   */
  const startRecording = async (): Promise<void> => {
    callObject?.startRecording();
    let recordingTimeout: ReturnType<typeof setTimeout>;
    return new Promise((resolve, reject) => {
      callObject?.once('recording-stopped', () => {
        recordingStatus.current = true;
      });
      callObject?.once('recording-started', () => {
        clearTimeout(recordingTimeout);
        recordingStatus.current = true;
        return resolve();
      });
      recordingTimeout = setTimeout(() => reject(new Error('StartRecording timed out')), 60 * 1000);
    });
  };

  const stopRecording = () => {
    callObject?.stopRecording();
    recordingStatus.current = false;
  };

  return {
    startRecording,
    stopRecording,
    isRecording: recordingStatus.current,
  };
};
